'use client';

import { useDarkMode } from '@/lib/platform/contexts/dark-mode-context';

interface SectionHeaderProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
}

export default function SectionHeader({ title, description, action }: SectionHeaderProps) {
  const { darkMode } = useDarkMode();

  return (
    <div
      className={`border-b pb-5 ${
        action ? 'sm:flex sm:items-center sm:justify-between' : ''
      } ${darkMode ? 'border-white/10' : 'border-gray-200'}`}
    >
      <div>
        <h3 className={`text-base font-semibold ${darkMode ? 'text-gray-100' : 'text-gray-900'}`}>
          {title}
        </h3>
        {description && (
          <p className={`mt-2 max-w-4xl text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
            {description}
          </p>
        )}
      </div>
      {action && <div className="mt-3 sm:mt-0 sm:ml-4">{action}</div>}
    </div>
  );
}
